/* Land Media · FAQ accordion (sections/lm-faq.liquid)
   Smooth open/close for <details>, single-open option, theme-editor aware. */
(function () {
  if (window.__lmFaqLoaded) return;
  window.__lmFaqLoaded = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(sec) {
    if (!sec || sec.__lmFaq) return;
    sec.__lmFaq = true;
    sec.classList.add('is-enhanced');
    var single = sec.hasAttribute('data-single');
    var items = Array.prototype.slice.call(sec.querySelectorAll('.lm-faq__item'));

    function open(d) {
      if (single) items.forEach(function (o) { if (o !== d && o.classList.contains('is-open')) close(o); });
      clearTimeout(d.__lmT);
      d.open = true;
      void d.offsetHeight;
      d.classList.add('is-open');
    }
    function close(d) {
      d.classList.remove('is-open');
      clearTimeout(d.__lmT);
      if (reduce) { d.open = false; return; }
      // Fallback in case transitionend does not fire.
      d.__lmT = setTimeout(function () { if (!d.classList.contains('is-open')) d.open = false; }, 700);
    }

    items.forEach(function (d) {
      if (d.open) d.classList.add('is-open');
      var panel = d.querySelector('.lm-faq__a');
      var summary = d.querySelector('summary');
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.classList.contains('is-open')) close(d); else open(d);
      });
      panel.addEventListener('transitionend', function (e) {
        if (e.target === panel && e.propertyName === 'grid-template-rows' && !d.classList.contains('is-open')) d.open = false;
      });
      // Keep the visual state in sync when <details> is opened or closed natively
      // (e.g. the browser's find-in-page auto-expanding a match, or another script).
      d.addEventListener('toggle', function () {
        if (d.open && !d.classList.contains('is-open')) open(d);
        else if (!d.open && d.classList.contains('is-open')) d.classList.remove('is-open');
      });
    });

    sec.__lmFaqOpen = open;
  }

  function init(root) {
    root = root || document;
    if (root.matches && root.matches('[data-lm-faq]')) setup(root);
    root.querySelectorAll('[data-lm-faq]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target.closest && e.target.closest('.lm-faq__item');
    if (!d) return;
    var sec = d.closest('[data-lm-faq]');
    if (sec && sec.__lmFaqOpen && !d.classList.contains('is-open')) sec.__lmFaqOpen(d);
  });
})();
